var map = {
	"./phoneSideBar/authority-active.png": "52e2",
	"./phoneSideBar/authority.png": "dba2",
	"./phoneSideBar/dealer-active.png": "d95e",
	"./phoneSideBar/dealer.png": "1072",
	"./phoneSideBar/device-active.png": "afc5",
	"./phoneSideBar/device.png": "8cf1",
	"./phoneSideBar/distribution-active.png": "833a",
	"./phoneSideBar/distribution.png": "fb4d",
	"./phoneSideBar/help-active.png": "06ef",
	"./phoneSideBar/help.png": "516d",
	"./phoneSideBar/home-active.png": "8f4f",
	"./phoneSideBar/home.png": "f51d",
	"./phoneSideBar/log-active.png": "c432",
	"./phoneSideBar/log.png": "e88b",
	"./phoneSideBar/setting-active.png": "c1ac",
	"./phoneSideBar/setting.png": "7627",
	"./phoneSideBar/storage-active.png": "12d6",
	"./phoneSideBar/storage.png": "8b0a",
	"./phoneSideBar/user-active.png": "762d",
	"./phoneSideBar/user.png": "39fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b889";